import axios, { isAxiosError } from "axios";
import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export interface postVPNAuthKeySupportSessionDto {
  namespace: string;
  id: string;
}

export const postVPNAuthKeySupportSession = async (
  payload: postVPNAuthKeySupportSessionDto,
) => {
  const { namespace, id } = payload;

  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/support-sessions/${id}/auth-key`,
      {},
      { headers },
    );

    return response?.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to generate support session auth key. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while generating support session auth key.",
      );
    }
  }
};
